import React, { useState, useRef, useEffect } from "react";
import { withRouter } from 'react-router';
import SwipeableViews from "react-swipeable-views";
import { Grid, Typography, Button } from "@material-ui/core";
import WizardHeader from 'components/wizardHeader';
import GeneralTab from "./wizard/GeneralTab";
import InstructionTab from "./wizard/InstructionTab";
import PermissionTab from './wizard/PermissionTab';
import ConsoleTab from "./wizard/ConsoleTab";
import TagTab from "./wizard/TagTab";
import ResourceTab from "./wizard/ResourceTab";
import TestTab from "./wizard/TestTab";
import { tabs } from "constants/admin/masters/labs";
import { useStyles } from './style';
import { getMasterBaseUrl } from "utils/masterHelpers";
import LabService from "services/LabService";
import LabMasterService from "services/admin/masters/LabService";
import { buildQueryParams } from "utils/common";
import _ from "lodash";
import { SHOW_LOADER } from "constants/common";
import store from "redux/store";

const labServiceObj = new LabService();
const labMasterServiceObj = new LabMasterService();

const Form = ({ history, ...props }) => {
    const classes = useStyles();
    const wrapperRef = useRef(null);
    const { url, params } = props.match;
    const { labId } = params;
    const masterUrl = getMasterBaseUrl(url, params);
    const [activeStep, setActiveStep] = useState(0);
    const [labDetails, setLabDetails] = useState({});
    const [instructionFileData, setInstructionFileData] = useState();
    const [videoUrl, setVideoUrl] = useState();
    const [activeConsoleScreen, setactiveConsoleScreen] = useState('');
    const redirect = (url) => {
        history.push(url);
    }
    function globalSpinner(payload) {
        return {
            type: SHOW_LOADER,
            payload
        }
    }
    useEffect(() => {
        if (wrapperRef && wrapperRef.current) wrapperRef.current.scrollTop = 0
        if (Number(labId) > 0) {
            let finalData = {};
            labServiceObj.getLabDetailsById(labId).then(response => {
                let updatedResponse = JSON.parse(JSON.stringify(response))
                const urlParams = { lab_id: labId }
                if (activeStep === 3) {
                    labServiceObj.getInstruction(buildQueryParams(urlParams)).then(response => {
                        if (response) {
                            finalData = {
                                ...updatedResponse,
                                content: response?.data.results[0]?.instruction_file,
                                video_instruction: response?.data.results[0]?.video_instruction,
                                id:response?.data.results[0]?.id
                            }
                        }
                        setLabDetails(finalData);
                        bindLocalStorageDataByLab(finalData)
                    })
                } else {

                    setLabDetails(updatedResponse);
                    bindLocalStorageDataByLab(updatedResponse)
                }


            }).catch(error => {
                console.log(error)
            });

        }
        //eslint-disable-next-line
    }, [activeStep]);

    useEffect(() => {
        let updateStep = JSON.parse(localStorage.getItem(labId))
        if (updateStep) {
            updateStep["step"] = 0
            localStorage.setItem(labId, JSON.stringify(updateStep))
        }
        return () => {
            localStorage.removeItem(labId)
            sessionStorage.removeItem("Add Lab")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const bindLocalStorageDataByLab = (response) => {
        bindLabData("step", response?.activeStep)
        bindLabData("name", response?.name)
        bindLabData("description", response?.description);
        bindLabData("status", response?.status);
        bindLabData("categories", response?.labcategories);
        bindLabData("lab_author_users", response?.lab_author_users);
        bindLabData("lab_author_groups", response?.lab_author_groups);
        bindLabData("max_time", response?.max_lab_time)
        bindLabData("tags", response?.tags);
        bindLabData("max_age", response?.max_age);
        bindLabData("content", response?.content);
        bindLabData("prespawn_count", response?.prespawn_count);
        bindLabData('is_public', response?.is_public);
        bindLabData('auto_suspend', response?.auto_suspend);
        bindLabData('lab_type', response?.lab_type);
        bindLabData('video_instruction', response?.video_instruction)
        bindLabData('id', response?.id)
    }

    const bindLabData = (key, value) => {
        let editLabDetails = JSON.parse(localStorage.getItem(labId)) ? JSON.parse(localStorage.getItem(labId)) : JSON.parse(sessionStorage.getItem("Add Lab")) ? JSON.parse(sessionStorage.getItem("Add Lab")) : {}
        editLabDetails[key] = value
        labId ? localStorage.setItem(labId, JSON.stringify(editLabDetails)) : sessionStorage.setItem("Add Lab", JSON.stringify(editLabDetails))
    }





    const handleChange = (index) => () => {
        //Disabling patch call which gets called after tab switch
        //const lastStep = Number(localStorage.step || 0);
        //editLab(lastStep, false);
        if (index !== 1 && checkActiveConsoleScreen) {
            setactiveConsoleScreen("")
        }
        setActiveStep(index);
        bindLabData("step", index)
    };
    const handlePrev = () => {
        setActiveStep(activeStep - 1);
        bindLabData("step", activeStep - 1)
    };

    const handleExit = () => {
        history.push('/admin/masters/labs')
        localStorage.removeItem(labId)
        sessionStorage.removeItem("Add Lab")
    };

    const handleSubmit = () => {
        setActiveStep(0);
        setLabDetails({});
        history.push('/admin/masters/labs/add');
    }

    const getSelectedCategories = (categories) => {
        let integerArray = [];
        if (categories && categories.length > 0) {
            for (var index = 0; index < categories.length; index++) {
                categories[index] && integerArray.push(parseInt(categories[index]));
            }
        }
        return integerArray;

    }

    const createGeneralTabPayload = () => {
        let labDetails = labId ? JSON.parse(localStorage.getItem(labId)) : JSON.parse(sessionStorage.getItem("Add Lab"))
        const payload = {
            name: labDetails?.name,
            description: labDetails?.description,
            status: labDetails?.status || "In Development",
            is_public: labDetails?.is_public ? labDetails?.is_public[0] === 0 || labDetails?.is_public === true ? true : false : false,
            auto_suspend: labDetails?.auto_suspend ? labDetails?.auto_suspend[0] === 0 || labDetails?.auto_suspend === true ? true : false : false,
            category: getSelectedCategories(labDetails.categories),
            max_age: labDetails?.max_age === "null" || _.isUndefined(labDetails?.max_age) ? null : Number(labDetails.max_age),
            prespawn_count: labDetails?.prespawn_count === "null" || _.isUndefined(labDetails?.prespawn_count) ? null : Number(labDetails.prespawn_count),
            lab_type: labDetails?.lab_type || "Run Lab"

        }

        return payload;
    }

    const createPermissionTabPayload = () => {
        let labDetails = JSON.parse(localStorage.getItem(labId))
        const payload = {
            user: getSelectedCategories(labDetails.users_permission),
            group: getSelectedCategories(labDetails.groups_permission),
        }
        return payload;
    }

    const createInstructionTabPayload = () => {
        const formData = new FormData();
        formData.append("instruction_file", instructionFileData);
        formData.append("lab", labId);
        if(_.isUndefined(videoUrl)){
            let labDetails = JSON.parse(localStorage.getItem(labId))
            formData.append("video_instruction", !_.isNull(labDetails?.video_instruction) ? labDetails?.video_instruction : "");
        }else{
            formData.append("video_instruction", videoUrl);
        }
        
        return formData;


    }

    const createTagTabPayload = () => {
        let labDetails = JSON.parse(localStorage.getItem(labId))
        const payload = {
            tags: getSelectedCategories(labDetails.tags)
        }
        return payload;
    }


    const createLab = () => {
        let payload = createGeneralTabPayload();
        labServiceObj.createLabUrl(payload).then(response => {
            if (response && response?.id) {
                window.location.href = `${masterUrl}/edit/${response?.id}`;
            }
        }).catch(err => {
            console.log(err)
        })
    }

    const createOrUpdateInstruction = (data, step, redirectionFlag) => {
        store.dispatch(globalSpinner(true))
        const instruction_file = data?.get("instruction_file")
        const video_instruction = data?.get("video_instruction")
        if(instruction_file === "undefined" && video_instruction==="undefined"){
            store.dispatch(globalSpinner(false))
            redirectionFlag && setActiveStep(step + 1)
        }else{
            if(instruction_file === "undefined" && (!_.isEmpty(video_instruction)|| _.isEmpty(video_instruction))){
                data?.delete("instruction_file")
                const labDetails = JSON.parse(localStorage.getItem(labId));
                if(_.isUndefined(labDetails?.id))
                {
                    labServiceObj.setInstruction(data).then(response => {
                        if (response) {
                            store.dispatch(globalSpinner(false))
                            redirectionFlag && setActiveStep(step + 1)
                        }
                    }).then(err => {
                        console.log(err)
                    })
                }else{
                    labServiceObj.updateInstruction(data, labDetails?.id, labId).then(response => {
                        if (response) {
                            store.dispatch(globalSpinner(false))
                            redirectionFlag && setActiveStep(step + 1)
                        }
                    }).then(err => {
                        console.log(err)
                    })
                }
            }else{
                if(video_instruction==="undefined"){
                    data?.delete("video_instruction")
                }   
                labServiceObj.setInstruction(data).then(response => {
                    if (response) {
                        store.dispatch(globalSpinner(false))
                        redirectionFlag && setActiveStep(step + 1)
                    }
                }).then(err => {
                    console.log(err)
                })
            }
            
        }
        
    }

    const editLab = (step, redirectionFlag) => {
        let payload = {};
        switch (step) {
            case 0:
                payload = createGeneralTabPayload();
                editLabData(payload, step, redirectionFlag);
                break;
            case 1:
                setActiveStep(step + 1);
                break;
            case 2:
                payload = createPermissionTabPayload();
                createOrEditPermissionData(payload, step, redirectionFlag);
                break;
            case 3:
                payload = createInstructionTabPayload();
                createOrUpdateInstruction(payload, step, redirectionFlag);
                break;
            case 4:
                payload = createTagTabPayload();
                editLabData(payload, step, redirectionFlag);
                break;
            case 5:
                break;

            case 6:

                break;
            default:
                break;
        }
    }

    const createOrEditPermissionData = (data, step, redirectionFlag) => {
        const { user_permissions, group_permissions } = labDetails;
        let labData = JSON.parse(localStorage.getItem(labId));
        const payload = {
            lab: labId,
            user: data?.user,
            max_time: parseInt(labData.max_time) > 0 ? parseInt(labData.max_time) : 0,
            max_extension: parseInt(labData.max_extension) > 0 ? parseInt(labData.max_extension) : 0
        }
        if (data?.user.length === 0 && data?.group.length === 0) {
            const userId = user_permissions[0]?.id;
            const groupId = group_permissions[0]?.id;

            if (userId) {
                labMasterServiceObj.deleteLabUserPermission(userId).then(() => {
                    redirectionFlag && setActiveStep(step + 1);
                }).catch(error => {
                    console.log(error)
                })
            }
            if (groupId) {
                labMasterServiceObj.deleteLabGroupPermission(groupId).then(() => {
                    redirectionFlag && setActiveStep(step + 1);
                }).catch(error => {
                    console.log(error)
                })
            }
        } else {
            if (data?.user && data?.user?.length > 0 && user_permissions.length === 0 && user_permissions) {
                labMasterServiceObj.createLabUserPermission(payload).then(response => {
                    if (response) {
                        redirectionFlag && setActiveStep(step + 1);
                    }
                }).catch(error => {
                    console.log(error)
                })
            }
            else if (user_permissions && user_permissions.length > 0 && (data?.user.length > 0 || data?.user.length === 0)) {
                const userId = user_permissions[0].id;
                if (data?.user.length === 0) {
                    labMasterServiceObj.deleteLabUserPermission(userId).then(() => {
                        redirectionFlag && setActiveStep(step + 1);
                    }).catch(error => {
                        console.log(error)
                    })
                } else {
                    labMasterServiceObj.updateLabUserPermission(payload, userId).then(response => {
                        if (response) {
                            redirectionFlag && setActiveStep(step + 1);
                        }
                    }).catch(error => {
                        console.log(error)
                    })
                }


            }
            if (group_permissions && group_permissions.length === 0 && data?.group && data?.group?.length > 0) {
                const payload = {
                    lab: labId,
                    group: data?.group,
                    max_time: parseInt(labData.max_time) > 0 ? parseInt(labData.max_time) : 0,
                    max_extension: parseInt(labData.max_extension) > 0 ? parseInt(labData.max_extension) : 0

                }
                labMasterServiceObj.createLabGroupPermission(payload).then(response => {
                    if (response) {
                        redirectionFlag && setActiveStep(step + 1);
                    }
                }).catch(error => {
                    console.log(error)
                })
            }
            else
                if (group_permissions && group_permissions.length === 1 && data?.group?.length === 0) {
                    const groupId = group_permissions[0].id;
                    labMasterServiceObj.deleteLabGroupPermission(groupId).then(() => {
                        redirectionFlag && setActiveStep(step + 1);
                    }).catch(error => {
                        console.log(error)
                    })
                } else {
                    if (group_permissions && group_permissions.length > 0 && data?.group?.length > 0) {
                        const groupId = group_permissions[0].id;
                        const payload = {
                            lab: labId,
                            group: data?.group,
                            max_time: parseInt(labData.max_time) > 0 ? parseInt(labData.max_time) : 0,
                            max_extension: parseInt(labData.max_extension) > 0 ? parseInt(labData.max_extension) : 0
                        }
                        labMasterServiceObj.updateLabGroupPermission(payload, groupId).then(response => {
                            if (response) {
                                redirectionFlag && setActiveStep(step + 1);
                            }
                        }).catch(error => {
                            console.log(error)
                        })
                    }
                } if (group_permissions && group_permissions.length > 0 && data?.group?.length === 0) {
                    const groupId = group_permissions[0].id;
                    labMasterServiceObj.deleteLabGroupPermission(groupId).then(() => {
                        redirectionFlag && setActiveStep(step + 1);
                    }).catch(error => {
                        console.log(error)
                    })
                }

        }



    }

    const editLabData = (payload, step, redirectionFlag) => {
        labServiceObj.editLabUrl(labId, payload).then(response => {
            if (response && response.lab_id) {
                redirectionFlag && setActiveStep(step + 1);
            }
        }).catch(err => {
            console.log(err)
        })
    }

    const bindGeneralInfo = (property, value) => {
        bindLabData(property, value)
    }

    const renderCurrentStep = (index) => {
        switch (index) {
            case 0:
                return <GeneralTab labId={labId} labDetails={labDetails} bindGeneralInfo={bindGeneralInfo} />
            case 1:
                return <ConsoleTab labId={labId} checkActiveConsoleScreen={checkActiveConsoleScreen} />
            case 2:
                return <PermissionTab labId={labId} labDetails={labDetails} bindGeneralInfo={bindGeneralInfo} />
            case 3:
                return <InstructionTab labId={labId} labDetails={labDetails} bindGeneralInfo={bindGeneralInfo} bindFileData={bindFileData} bindVideoData={bindVideoData} />
            case 4:
                return <TagTab labId={labId} labDetails={labDetails} bindGeneralInfo={bindGeneralInfo} />
            case 5:
                return <ResourceTab labId={labId} labDetails={labDetails} />
            case 6:
                return <TestTab labId={labId} testDetails={labDetails} />
            default:
                return <GeneralTab labId={labId} labDetails={labDetails} bindGeneralInfo={bindGeneralInfo} />
        }

    }

    const checkActiveConsoleScreen = (activeScreenType) => {
        setactiveConsoleScreen(activeScreenType)
    }

    const bindFileData = (fileData) => {
        setInstructionFileData(fileData)
    }

    const bindVideoData = (videoUrl) => {
        setVideoUrl(videoUrl)
    }

    return (
        <>
            <div className={classes.labMaster}>
                <div className={classes.labformContainer}>
                    <Typography variant="h6" gutterBottom className={classes.pageTitle}> ADD LAB {labId && labDetails?.name && " > " + labDetails.name} </Typography>
                    <Grid container item xs={4} className={classes.gridContainer}>
                        {!activeConsoleScreen && <Grid item>
                            <Button

                                onClick={handleExit}
                                variant="contained"
                                className={classes.nextBtn}
                            >
                                Exit
                            </Button>
                            <Button

                                disabled={activeStep === 0}
                                onClick={handlePrev}
                                variant="contained"
                                color="default"
                                className={activeStep === 0 ? classes.disableBtn : classes.prevBtn}
                            >
                                Back
                            </Button>

                            {activeStep < tabs.length - 1 && (
                                <Button
                                    className={classes.nextBtn}
                                    variant="contained"
                                    onClick={labId ? () => editLab(activeStep, true) : () => createLab()}
                                >
                                    {labId ? 'Save' : 'Submit'}
                                </Button>
                            )}

                            {activeStep === tabs.length - 1 && (
                                <Button
                                    className={classes.nextBtn}
                                    type="submit"
                                    color="primary"
                                    variant="contained"
                                    onClick={() => {
                                        handleSubmit(); redirect('/admin/masters/labs');
                                    }}
                                >
                                    Submit
                                </Button>
                            )}
                        </Grid>
                        }
                    </Grid>
                </div>
                <WizardHeader
                    tabs={tabs}
                    activeStep={activeStep}
                    handleChange={handleChange}
                    labId={labId}
                />
                <form ref={wrapperRef} >

                    <SwipeableViews index={activeStep} onChangeIndex={handleChange} >
                        {[GeneralTab, ConsoleTab, PermissionTab, InstructionTab, TagTab, ResourceTab, TestTab].map((step, index) => {
                            return (
                                <div style={index === 4 ? { paddingBottom: '16px', overflow: 'hidden', height: '406px' } : { paddingBottom: '16px', overflowX: 'hidden' }} key={index} hidden={index !== activeStep} aria-labelledby={`step-${index}`}>
                                    {index === activeStep && renderCurrentStep(activeStep)}
                                </div>
                            )
                        })}
                    </SwipeableViews>
                </form>
            </div>
        </>

    );
};
export default withRouter(Form);